import React, { useRef, useState, useEffect } from 'react';
import { Spinner } from '@cochlear-design-system/foundation';
import { routes } from '../../../config';
import { setIdpParam } from '../../../utils/authprovider';
import providerService from '../../../services/providerService';
import { shouldRedirectForClinicSync } from '../../../utils/mcpClinicSync';
import ClinicSyncFrame from '../../ClinicSyncFrame';

const LegacyClinicEquipment = () => {
  const clinicEquipmentFrame = useRef();
  const [showClinicEquipment, setShowClinicEquipment] =
    useState(false);
  const [showSpinner, setShowSpinner] = useState(true);
  const { providerId } = providerService.getProviderDetails();

  // The clinic equipment iframe assumes MCP already has the correct active
  // clinic. We let the user view this page and see the "Enable Now" alert while
  // the MCP session is not yet established. Clicking "Enable Now" warms up the
  // session and reloads this page (handled by useMcpEvents). When the session
  // is live but the clinic hasn't been synced yet, we switch MCP's active
  // clinic in place (via ClinicSyncFrame), then
  // render the clinic equipment iframe once the sync is confirmed.
  const [needsClinicSync, setNeedsClinicSync] = useState(() =>
    shouldRedirectForClinicSync(providerId),
  );

  useEffect(() => {
    const handleEvent = () => {
      setShowSpinner(true);
      setShowClinicEquipment(false);
      if (clinicEquipmentFrame && clinicEquipmentFrame.current) {
        clinicEquipmentFrame.current.style.height = '100px';
      }
    };

    window.addEventListener('popstate', handleEvent);

    return () => {
      window.removeEventListener('popstate', handleEvent);
    };
  }, []);

  useEffect(() => {
    const handleMessage = (e) => {
      if (e.origin !== routes.mcp.domain) return;
      if (typeof e.data === 'object') {
        if ('pageEvent' in e.data) {
          const mcpPageHeigth = e.data.pageEvent.payload?.height;
          switch (e.data.pageEvent.type) {
            case 'pageLoaded':
              if (
                e.data.pageEvent.target === 'clinicEquipment' ||
                e.data.pageEvent.target ===
                  'selectedServiceRequest' ||
                e.data.pageEvent.target === 'createServiceRequest'
              ) {
                if (
                  clinicEquipmentFrame &&
                  clinicEquipmentFrame.current
                ) {
                  setShowSpinner(false);
                  setShowClinicEquipment(true);
                  clinicEquipmentFrame.current.style.height =
                    mcpPageHeigth === 0
                      ? '1000px'
                      : `${mcpPageHeigth}px`;
                }
              }
              break;
            case 'loading':
              if (e.data.pageEvent.target === 'clinicEquipment') {
                setShowSpinner(true);
                setShowClinicEquipment(false);
                if (
                  clinicEquipmentFrame &&
                  clinicEquipmentFrame.current
                ) {
                  clinicEquipmentFrame.current.style.height = '100px';
                }
              }
              break;
            default:
              break;
          }
        }
      }
    };
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <div>
      {needsClinicSync && (
        <ClinicSyncFrame
          cochlearId={providerId}
          onSynced={() => setNeedsClinicSync(false)}
        />
      )}
      {showSpinner && (
        <div className="spinner">
          <Spinner animation="border" />
        </div>
      )}
      {!needsClinicSync && (
        <iframe
          src={setIdpParam(`${routes.mcp.clinicEquipment}`)}
          id="clinic-equipment-iframe"
          title="clinic-equipment"
          width="100%"
          ref={clinicEquipmentFrame}
          style={{
            visibility: showClinicEquipment ? 'visible' : 'hidden',
          }}
        />
      )}
    </div>
  );
};

export default LegacyClinicEquipment;
